'use strict';

/**
 * @ngdoc function
 * @name courseApp.controller:AttendeeController
 * @description
 * # AttendeeController
 * Controller of the courseApp
 */
angular.module('courseApp')
    .controller('AttendeeController', function ($filter, Utils, ActCourseService, APIs, ConfigService) {
        var vm = this;
        vm.selectedAttendee = undefined;
        vm.printDialog = false;
        vm.showDelAttendee = false;
        vm.selectedCourse = ActCourseService.getActCourse();

        vm.showDialog = function (dialog) {
            vm[dialog] = true;
        };

        vm.hideDialog = function (dialog) {
            vm[dialog] = false;
        };

        vm.delAttendee = function () {
            APIs.AttendeeService.delete(vm.selectedAttendee, function () {
                vm.selectedAttendee = $filter('filter')(vm.attendeeList, { id: vm.selectedAttendee.id })[0];
                vm.attendeeList.splice(vm.attendeeList.indexOf(vm.selectedAttendee), 1);
                vm.tableParams.settings({
                    dataset: vm.attendeeList
                });
                vm.hideDialog('showDelAttendee');
            });
        };

        vm.printCheckIn = function () {
            var pdfURL = ConfigService.CONFIG.backendURL + 'course/pdf/attendee/checkin/' + vm.selectedCourse.id + '/';
            Utils.savePDFFile(pdfURL, vm.selectedCourse.short_name + '_checkin.pdf');
            vm.hideDialog('printDialog');
        };

        vm.printSignature = function () {
            var pdfURL = ConfigService.CONFIG.backendURL + 'course/pdf/attendee/signature/' + vm.selectedCourse.id + '/';
            Utils.savePDFFile(pdfURL, vm.selectedCourse.short_name + '_signature.pdf');
            vm.hideDialog('printDialog');
        };

        vm.printPlanning = function () {
            var pdfURL = ConfigService.CONFIG.backendURL + 'course/pdf/attendee/planning/' + vm.selectedCourse.id + '/';
            Utils.savePDFFile(pdfURL, vm.selectedCourse.short_name + '_planning.pdf');
            vm.hideDialog('printDialog');
        };

        vm.printLiftcard = function () {
            var pdfURL = ConfigService.CONFIG.backendURL + 'course/pdf/attendee/liftcard/' + vm.selectedCourse.id + '/';
            Utils.savePDFFile(pdfURL, vm.selectedCourse.short_name + '_liftcard.pdf');
            vm.hideDialog('printDialog');
        };

        var lsvSelectOptions = [];
        APIs.LSVService.query().$promise.then(function (data) {
            angular.forEach(data, function (lsv) {
                lsvSelectOptions.push({ id: lsv.short_name, title: lsv.short_name });
            });
        });

        vm.attendeeList = [];
        if (angular.isDefined(vm.selectedCourse) && vm.selectedCourse !== null) {
            APIs.AttendeeService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (attendee) {
                    vm.attendeeList.push(attendee);
                });
                vm.tableParams.settings({
                    dataset: vm.attendeeList
                });
            });
        }

        vm.cols = [
            { valueExpr: 'attendee.person.name', title: 'Name', sortable: 'person.name', filter: { 'person.name': 'text' }, show: true },
            { valueExpr: 'attendee.person.first_name', title: 'Vorname', sortable: 'person.first_name', filter: { 'person.first_name': 'text' }, show: true },
            { valueExpr: 'attendee.person.birthday | date:\'dd.MM.yyyy\'', title: 'GebDatum', show: true },
            { valueExpr: 'attendee.person.lsv.short_name', title: 'LSV', sortable: 'person.lsv.short_name', filter: { 'person.lsv.short_name': 'select' }, filterData: lsvSelectOptions, show: true },
            { valueExpr: 'attendee.type', title: 'Art', sortable: 'type', filter: { type: 'select' }, filterData: ConfigService.ATTENDEE_TYPE, show: true },
            { valueExpr: 'attendee.person.lizenz', title: 'Stufe', sortable: 'person.lizenz', filter: { 'person.lizenz': 'text' }, show: true }
        ];

        vm.tableParams = new ConfigService.NgTableParams({ page: 1, count: 10 }, {
            defaultSelectValue: 'Show all',
            dataset: vm.attendeeList
        });

        vm.setSelected = function (attendee) {
            vm.selectedAttendee = attendee;
        };
    });
